import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import useStyles from "../../styles/deviceStyle";
import { useTranslation } from "../../langs/useTranslation";
import HOCforFullWidthTable from "../../hoc/FullWidthTableWrapper";
import "../../css/dataTable.css";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import { taskResendMap } from "../../helpers/taskResendMap";
import TaskResendDialog from "./TaskResendDialog";
import { ResendTaskAPI } from "../../apis/resendTaskAPI";
import { handleNewOrOldVnc } from "../../helpers/vncLinkHandler";
// import { OnlineStatusContext } from "../../containers/DeviceDetail";
import { url } from "../../apis/apiSetup";
import * as localforage from "localforage";
import * as $ from "jquery";
import "datatables.net";
//import StatusChip from "../components/commons/StatusChip";
import { searchStyleRender } from "../../helpers/datatableSearchStyleRender";
// import HasPermission from "../components/commons/HasPermission";
import { language } from "../../helpers/datatableLanguage";
import { utcStringToLocalDatetimeConverter } from "../../helpers/datetimeHandlers";
import TaskStatusBar from "../commons/TaskStatusBar";
import { ReactRender } from "../ReactRender";
import { errorHandling } from "@/helpers/errorHandling";

const DeviceDetailTaskHistory = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    dispatch,
    deviceData,
    openResendDialog,
    setOpenResendDialog,
    taskId,
    taskName,
    device_id,
    handleResendDialogClose,
    handleResendDialogOpen,
    setOnlineStatus
  } = props;
  const { t } = useTranslation("device");
  const [taskType, setTaskType] = useState(1);

  const table = async (t, device_id, handleResendDialogOpen) => {
    const token = await localforage.getItem("token");
    const searchValue = $("#task-history-list-table_filter input").val();
    let onlineOffline = "";

    $("#task-history-list-table").DataTable({
      serverSide: true,
      processing: true,
      language: language(t),
      searching: false, // true,
      order: [[2, "desc"]],
      filter: false,
      deferRender: true,
      info: true,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 5,
      ordering: true,
      ajax: {
        url: `${url}/api/v2/device/tasks`,
        type: "GET",
        dataSrc: function (d) {
          setOnlineStatus(d.online_offline_status);
          onlineOffline = d.online_offline_status;
          return d.data;
        },
        data: {
          device_id: device_id,
          search: searchValue || undefined,
          task_type: taskType
        },
        beforeSend: request => {
          request.setRequestHeader("Authorization", "Bearer " + token);
          request.setRequestHeader("Accept", "application/json");
        },
        error: err => {
          errorHandling(err);
        }
      },
      columns: [
        {
          data: "execute_type",
          title: `${t("category.taskName")}`,
          createdCell: (td, data, rowData) => {
            ReactRender(
              <p className="task_name">
                {data === "device_power" &&
                rowData.json &&
                rowData.json.system_booting_type ? (
                  <>
                    {t(`tasks.${data}`)} - [{" "}
                    {t(`tasks.${rowData.json.system_booting_type}`)} ]
                  </>
                ) : (data === "lock_usb" ||
                    data === "disable_combination_key" ||
                    data === "disable_windows_notify") &&
                  rowData.json ? (
                  t(`tasks.${data}_${rowData.json.status}`)
                ) : (
                  t(`tasks.${data}`)
                )}
              </p>,
              td
            );
          }
        },
        {
          data: "user",
          name: "user.name",
          title: `${t("category.user")}`,
          render: data => {
            return data.name;
          }
        },
        {
          data: "executed_at",
          className: "date",
          title: `${t("category.date")}`,
          searchable: true,
          render: data => {
            return utcStringToLocalDatetimeConverter(data);
          }
        },
        {
          data: "status",
          title: `${t("category.status")}`,
          className: "status",
          createdCell: (td, data, rowData) => {
            ReactRender(
              <TaskStatusBar
                taskType={rowData.task_type || taskType}
                status={data}
                message={rowData.response === "" ? null : rowData.response}
                isOffline={onlineOffline !== "online"}
              />,
              /* <StatusChip
                            statusLabel={data}
                            id={rowData.id}
                            ariaDescribeBy={rowData.id}
                            popoverText={data === "failed" ? rowData.response : undefined}
                        />*/ td
            );
          }
        }
        // {
        //   data: "status",
        //   title: `${t("category.action")}`,
        //   searchable: false,
        //   className: "resend-btn-td",
        //   orderDataType: "dom-text",
        //   createdCell: (td, data, rowData) => {
        //     const task_id = rowData.id;
        //     const task_name = rowData.execute_type;
        //     if (data === "failed") {
        //       ReactRender(
        //         <HasPermission permission="single_task_resend">
        //           <span
        //             onClick={() => handleResendDialogOpen(task_id, task_name)}
        //           >
        //             {t("btn.resend")}
        //           </span>
        //         </HasPermission>,
        //         td
        //       );
        //     } else {
        //       ReactRender("-", td);
        //     }
        //   },
        // },
      ]
    });
    searchStyleRender();
  };

  const handleReloadDataTable = () => {
    table(t, device_id, handleResendDialogOpen);
  };

  const handleResendTask = async () => {
    dispatch({ type: "showLoading" });

    const newVnc = handleNewOrOldVnc(deviceData);
    const taskMap = taskResendMap(newVnc);

    taskMap.map(async taskNameObject => {
      if (taskNameObject.taskName === taskName) {
        const resendTaskName = taskNameObject.resendTaskName;
        const data =
          resendTaskName === "vnc_connect"
            ? { task_id: taskId }
            : { task_id: taskId, nubis_version: props.nubisVersion };
        await ResendTaskAPI(
          resendTaskName,
          data,
          t,
          dispatch,
          setOpenResendDialog
        );
      }
    });
  };

  useImperativeHandle(ref, () => ({
    reload: () => handleReloadDataTable()
  }));

  useEffect(() => {
    handleReloadDataTable();
  }, [taskType]);

  return (
    <div>
      <Box display="flex" alignItems="center" mb={2}>
        <Typography
          variant="h5"
          className={`${classes.detailTitle} ${classes.detailTitle2}`}
        >
          {t("deviceDetail.taskHistory")}
          <AutorenewRoundedIcon
            onClick={handleReloadDataTable}
            size="small"
            className={`${classes.listBtn} ${classes.reload_btn}`}
          />
        </Typography>
        <div>
          <Button
            variant="outlined"
            color={taskType === 1 ? "primary" : "default"}
            className={classes.taskTypeBtn}
            onClick={() => {
              setTaskType(1);
            }}
          >
            Command Info
          </Button>
          <Button
            variant="outlined"
            color={taskType === 2 ? "primary" : "default"}
            className={classes.taskTypeBtn}
            onClick={() => {
              setTaskType(2);
            }}
          >
            Sync Info
          </Button>
        </div>
      </Box>
      <HOCforFullWidthTable searching={false}>
        <table id="task-history-list-table" className="mdl-data-table"></table>
      </HOCforFullWidthTable>
      <TaskResendDialog
        handleResendTask={handleResendTask}
        handleResendDialogClose={handleResendDialogClose}
        openResendDialog={openResendDialog}
      />
    </div>
  );
});

export default DeviceDetailTaskHistory;
